import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { readCookie } from '@outputinc/o-logins'
import { useRecaptchaStore } from '@/store/RecaptchaStore'

const getHeaders = (): Headers => {
  const headers: Headers = new Headers()
  const token = readCookie(import.meta.env.VITE_OUTPUT_TOKEN_COOKIE_NAME, false)

  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
    headers.set('Unique-Machine-Id', 'machine')
  }

  const { removeRecaptcha, recaptchaToken } = useRecaptchaStore()

  if (recaptchaToken) {
    headers.set('x-ocaptcha', recaptchaToken)
    removeRecaptcha()
  }

  headers.set('Content-Type', 'application/json')

  return headers
}

// HTTP connection to the API
const httpLink = createHttpLink({
  uri: `${import.meta.env.VITE_ROAD_MANAGER_BASE_URL}/rmquery`,
  fetch: (uri, options) => {
    if (options) {
      options.headers = getHeaders()
    }
    return fetch(uri, options)
  }
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
export const apolloClient = new ApolloClient({
  cache,
  link: httpLink,
  defaultOptions: {
    query: {
      errorPolicy: 'all'
    },
    mutate: {
      errorPolicy: 'all'
    }
  },
  connectToDevTools: import.meta.env.VITE_OUTPUT_ENVIRONMENT !== 'production'
})
